import {
  BusRequestType,
  ClassAddStudentType,
  ClassRequestType,
  DeviceRequestType,
  LoginInfo,
  SitePostType,
  StudentRequestType,
  UserPostType,
  UserSiteRequestType,
  SyncStudentDeviceRequestType,
  SmsAuthRequestType, DdnsRequestType, AttendanceCountQueryParams
} from "type/type";
import TimeoutController from "./TimeoutController";
import {globalSiteIdUpdate, SITEID} from "../redux/hook/useLoginUserInfo";

const protocol = window.location.protocol;
// const hostname = process.env.REACT_APP_HOSTNAME;
// const port = process.env.REACT_APP_SERVER_PORT;
const deploy:string|undefined = process.env.REACT_APP_DEPLOY;
const hostname = deploy === "development" ? "127.0.0.1" :  window.location.hostname;
const port = deploy === "development" ? "4500" : window.location.port;
export const url = `${protocol}//${hostname}:${port}`;

// FIXME: test시 site_id, company_id 1로 고정
const TESTCOMPANYID = 1;

// --------------------------- SMS 인증 관련 시작 ------------------------------------
/**
 * 회원가입 시 SMS 인증 번호 요청
 * @param data - name/phone/resident_number/gender/sms_type
 * @returns 
 */
export async function getSmsAuthRequest(data: SmsAuthRequestType): Promise<any> {
  return await apiRequestHandler(`/v1/sms/auth-request`, "POST", data);
}

/**
 * SMS 인증 번호 요청
 * SIGNUP:회원가입, ID_FIND:아이디찾기, PASSWORD_FIND:비밀번호 찾기, USER_INFO_CHANGE:내정보(휴대폰번호) 변경
 * @param data - name/phone/sms_type
 * @returns 
 */
export async function getSmsAuthCommonRequest(data: SmsAuthRequestType): Promise<any> {
  return await apiRequestHandler(`/v1/sms/auth-request-common`, "POST", data);
}

/**
 * SMS 인증 번호 검증
 * @param phone 핸드폰번호
 * @param verification_code 인증번호
 * @returns
 */
export async function getSmsAuthVerify(
  phone: string,
  verification_code: string
): Promise<any> {
  return await apiRequestHandler(`/v1/sms/auth-verify`, "POST", {
    phone,
    verification_code,
  });
}
// --------------------------- SMS 인증 관련 끝 ------------------------------------
// --------------------------- 회원가입 관련 시작 ------------------------------------
export async function checkDuplicateUserId(): Promise<any> {
  return await apiRequestHandler(`/v1/user-all`, "GET");
}

/**
 * 회원가입 시 사용자 휴대폰번호 중복 체크
 * @param phone 
 * @returns 
 */
export async function checkExistPhoneNumber(phone: string): Promise<any> {
  return await apiRequestHandler(`/v1/user/phone-number/exists?phone=${phone}`, "GET");
}

/**
 * 사용자 회원가입 - 원장님/선생님
 * @param signData
 * @returns
 */
export async function postSignUser(signData: any, site_id: number): Promise<any> {
  const { class_id, user } = signData;
  
  const userSiteRequestType: UserSiteRequestType = {
    site_id,
    approval: user.role === "ROLE_DIRECTOR" ? 1 : 0
  };
  
  let data: UserPostType = {
    user_site_list: [userSiteRequestType],
    name: user.name,
    email: user.email || "",
    phone: user.phone,
    resident_number: user.resident_number,
    gender: user.gender,
    role: user.role,
    login_id: user.login_id,
    login_pw: user.login_pw,
    temp_phone: "",
    terms_agree: user.terms_agree,
    unique_code: "",
    card_no: "",
    class_id: user.role === "ROLE_PARENT" ? 0 : class_id,
    student_id: 0,
    temp_mobile_os: 0,
    temp_mobile_token: "",
    base64_list: [],
  };

  return await apiRequestHandler(`/v1/user`, "POST", data);
}
export async function postSignSite(signData: any): Promise<any> {
  let data: SitePostType = {
    company_id: 1, // FIXME: 추후에 수정
    type: 1, // FIXME: 추후에 수정
    name: signData.name,
    full_address: signData.full_address,
    detail_address: signData.detail_address || "",
    phone: signData.phone,
    fax: "",
    email: signData.email,
    temp_phone: "",
    approval: 1,
    base64_list: [],
  };

  return await apiRequestHandler(`/v1/site`, "POST", data);
}

export async function getSignClass(siteId: any): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${siteId}/class-all`, "GET");
}
// --------------------------- 회원가입 관련 끝 ------------------------------------
// --------------------------- 업장 관련 시작 ------------------------------------
/**
 * 업장(site) 조회
 * @param prop
 * @ name: string address: string detail_address: string sido: string sigungu: string
 * @ eupmyeondong: string ri: string latitude: number longitude: number page: number size: number
 * @returns
 */
export async function getSite(prop?: any): Promise<any> {
  let param = "";
  if (prop !== undefined) {
    for (let i = 0; i < Object.keys(prop).length; i++) {
      let key = Object.keys(prop)[i];
      param +=
        key === "name"
          ? `&name=${prop.name}`
          : key === "page"
          ? `&page=${prop.page}`
          : key === "size"
          ? `&size=${prop.size}`
          : key === "address"
          ? `&address=${prop.address}`
          : key === "detail_address"
          ? `&detail_address=${prop.detail_address}`
          : key === "sido"
          ? `&sido=${prop.sido}`
          : key === "sigungu"
          ? `&sigungu=${prop.sigungu}`
          : key === "eupmyeondong"
          ? `&eupmyeondong=${prop.eupmyeondong}`
          : key === "ri"
          ? `&ri=${prop.ri}`
          : key === "latitude"
          ? `&latitude=${prop.latitude}`
          : key === "longitude"
          ? `&longitude=${prop.longitude}`
          : "";
    }
    if (Object.keys(prop).length !== 0)
      param = `?${param.slice(1, param.length)}`;
  }

  return await apiRequestHandler(
    `/v1/site-all/${TESTCOMPANYID}${param}`,
    "GET"
  );
}

export async function getSiteOne(): Promise<any> {

  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  // siteId(원 선택 및 전환을 했을 경우)
  // let site_id = siteId ? siteId : SITEID && SITEID.length > 0 ? SITEID[0] : 0;
  return await apiRequestHandler(`/v1/site/${SITEID}`, "GET");
}
// --------------------------- 업장 관련 끝 ------------------------------------

// --------------------------- user 관련 시작 ------------------------------------
/**
 * 사용자 조회
 * @param prop
 * @returns
 */
export async function getUser(prop?: any): Promise<any> {
  let param = "";
  if (prop !== undefined) {
    for (let i = 0; i < Object.keys(prop).length; i++) {
      let key = Object.keys(prop)[i];
      param +=
        key === "name" ? `&name=${prop.name}`
            : key === "page" ? `&page=${prop.page}`
                : key === "size" ? `&size=${prop.size}`
                    : key === "user_id" ? `&user_id=${prop.user_id}`
                      : key === "role" ? `&role=${prop.role}`
                          : key === "class_id" ? `&class_id=${prop.class_id}`
                              : key === "site_id" ? `&site_id=${prop.site_id}`
                                  : key === "approval" ? `&approval=${prop.approval}`
                                    : "";
    }
    if (Object.keys(prop).length !== 0)
      param = `?${param.slice(1, param.length)}`;
  }
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/user-all${param}`, "GET");
}

/**
 * 사용자 한 명 조회
 * @param userIdx number
 * @returns
 */
export async function getUserOne(userIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/user/${userIdx}`, "GET");
}
/**
 * 사용자 주요 정보 간소화 조회
 * @param userIdx number
 * @returns
 */
export async function getUserInfo(userIdx: number): Promise<any> {
  return await apiRequestHandler(`/v1/user-info/${userIdx}`, "GET");
}

export async function userApproval(userId: number, approval: number): Promise<any> {
  return await apiRequestHandler(`/v1/user-approval/${userId}`, "PUT", { approval, site_id:SITEID });
}

// --------------------------- user 관련 끝 ------------------------------------
// --------------------------- 반 관련 시작 ------------------------------------
/**
 * 반 조회
 * @param prop { page: number 페이지번호, size: number 한페이지에 보여줄 게시물 수, name:string 반이름, user_id: number선생님 id(현재 x) }
 * @returns
 */
export async function getClass(prop?: any): Promise<any> {
  let param = "";
  if (prop !== undefined) {
    for (let i = 0; i < Object.keys(prop).length; i++) {
      let key = Object.keys(prop)[i];
      param +=
        key === "page" ? `&page=${prop.page}`
        : key === "size" ? `&size=${prop.size}`
          : key === "name" ? `&name=${prop.name}`
            : key === "user_id" ? `&user_id=${prop.user_id}`
              : key === "response_type" ? `&response_type=${prop.response_type}`
                : "";
    }
    if (Object.keys(prop).length !== 0)
      param = `?${param.slice(1, param.length)}`;
  }
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/class-all${param}`, "GET"
  );
}
// 반 단건 조회
export async function findClassHandler(classId: number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/class/${classId}`, "GET");
}
// --------------------------- 반 관련 끝 ------------------------------------
// --------------------------- 학생 관련 시작 ------------------------------------
/**
 * 학생 조회
 * @param prop { page: number 페이지번호, size: number 한페이지에 보여줄 게시물 수, name:string 학생 이름, class_id: number 반 ID }
 * @returns
 */
export async function getStudent(prop?: any): Promise<any> {
  let param = "";
  if (prop !== undefined) {
    for (let i = 0; i < Object.keys(prop).length; i++) {
      let key = Object.keys(prop)[i];
      param +=
          key === "page" ? `&page=${prop.page}` :
            key === "size" ? `&size=${prop.size}` :
              key === "name" ? `&name=${prop.name}` :
                key === "class_id" ? `&class_id=${prop.class_id}` :
                  key === "user_id" ? `&user_id=${prop.user_id}` :
                    "";
    }
    if (Object.keys(prop).length !== 0)
      param = `?${param.slice(1, param.length)}`;
  }
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/student-all${param}`,
    "GET"
  );
}
//학생 단건 조회
export async function getStudentOne(studentId: number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/student/${studentId}`, "GET");
}

// --------------------------- 학생 관련 끝 ------------------------------------
// --------------------------- 알림장 관련 시작 ------------------------------------
/**
 * 알림장 조회
 * @param prop
 * @ start_date: string (현재는 start_date, end_date 동일) title: string, content: string
 * @ class_id: number, student_id: number
 * @returns
 */
export async function getNotebook(prop?: any): Promise<any> {
  let param = "";
  if (prop !== undefined) {
    for (let i = 0; i < Object.keys(prop).length; i++) {
      let key = Object.keys(prop)[i];
      let value = prop[key];
      if (Number(value) !== 0) {
        param +=
          key === "page" ? `&page=${prop.page}`
            : key === "size" ? `&size=${prop.size}`
              : key === "title" ? `&title=${prop.title}`
                : key === "content" ? `&content=${prop.content}`
                  : key === "note_start_date" ? `&note_start_date=${prop.note_start_date}&note_end_date=${prop.note_start_date}`
                    : key === "create_user_type" ?  `&create_user_type=${prop.create_user_type}`
                      : key === "class_id" ? `&class_id=${prop.class_id}`
                        : key === "student_id" ? `&student_id=${prop.student_id}`
                          : "";
      }
    }
    if (Object.keys(prop).length !== 0)
      param = `?${param.slice(1, param.length)}`;
  }
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/notebook-all${param}`,
    "GET"
  );
}
/**
 * 알림장 등록
 * @param data 알림장 등록 data
 * @returns
 */
export async function postNotebook(data: any): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await formDataApiRequestHandler(
    `/v1/sites/${SITEID}/notebook`,
    "POST",
    data
  );
}
/**
 * 알림장 수정
 * @param notebookIndex 알림장 index
 * @param data 수정 data
 * @returns
 */
export async function putNotebook(notebookIndex: number, data: any): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await formDataApiRequestHandler(`/v1/sites/${SITEID}/notebook/${notebookIndex}`, "PUT", data);
}
/**
 * 알림장 삭제
 * @param notebookIndex 알림장 index
 * @returns
 */
export async function deleteNotebook(notebookIndex: number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/notebook/${notebookIndex}`,
    "DELETE"
  );
}

// --------------------------- 알림장 관련 끝 ------------------------------------
// --------------------------- 공지사항 관련 시작 ------------------------------------
/**
 * 공지사항 조회
 * @param prop page: number, size: number, title: string, content: string, class_id: number
 * @returns
 */
export async function getNotice(prop?: any): Promise<any> {
  let param = "";
  if (prop !== undefined) {
    for (let i = 0; i < Object.keys(prop).length; i++) {
      let key = Object.keys(prop)[i];
      let value = prop[key];
      if (Number(value) !== 0) {
        param +=
          key === "page"
            ? `&page=${prop.page}`
            : key === "size"
            ? `&size=${prop.size}`
            : key === "title"
            ? `&title=${prop.title}`
            : key === "content"
            ? `&content=${prop.content}`
            : key === "class_id"
            ? `&class_id=${prop.class_id}`
            : "";
      }
    }
    if (Object.keys(prop).length !== 0)
      param = `?${param.slice(1, param.length)}`;
  }
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/notice-all${param}`,
    "GET"
  );
}
/**
 * 공지사항 등록
 * @param data 공지사항 등록 data
 * @returns
 */
export async function postNotice(data: any): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await formDataApiRequestHandler(
    `/v1/sites/${SITEID}/notice`,
    "POST",
    data
  );
}
/**
 * 공지사항 수정
 * @param noticeIndex 공지사항 index
 * @param data 수정 data
 * @returns
 */
export async function putNotice(noticeIndex: number, data: any): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await formDataApiRequestHandler(
    `/v1/sites/${SITEID}/notice/${noticeIndex}`,
    "PUT",
    data
  );
}
/**
 * 공지사항 삭제
 * @param noticeIndex 공지사항 index
 * @returns
 */
export async function deleteNotice(noticeIndex: number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/notice/${noticeIndex}`,
    "DELETE"
  );
}
// --------------------------- 공지사항 관련 끝 ------------------------------------
// --------------------------- 이미지/문서 불러오기 관련 시작 ------------------------------------
export async function getFileOrigin(file_name: string): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await downloadApiRequestHandler(
    `/v1/sites/${SITEID}/file?file_name=${file_name}`,
    "GET"
  );
}
// --------------------------- 이미지/문서 불러오기 관련 끝 ------------------------------------

export function getImageUrl(file_name: string):string {
  return `${url}/v1/sites/${SITEID}/file?file_name=${file_name}`;
}


export enum ExcelFormType {
  CREATE_ALL_STUDENT = "CREATE_ALL_STUDENT"
}
// 엑셀 폼 양식 다운로드
export async function excelFormDownload(formType: ExcelFormType):Promise<any> {
  return await downloadApiRequestHandler(`/v1/sites/${SITEID}/excel-file-download?excel_form_type=${formType}`, "GET");
}


// --------------------------- 출석부 관련 시작 ------------------------------------
/**
 * 출석부 조회 - 기존()
 * @param prop student_id: number, class_id: number, start_date: string, end_date: string
 * @ 일간: start_date = end_date, 월간: start_date = 1, end_date = 28/29/30/31
 * @returns
 */
export async function getAttendance(prop?: any): Promise<any> {
  //   console.log("prop ", prop);
  let param = "";
  if (prop !== undefined) {
    for (let i = 0; i < Object.keys(prop).length; i++) {
      let key = Object.keys(prop)[i];
      let value = prop[key];
      if (Number(value) !== 0) {
        param +=
          key === "student_id"
            ? `&student_id=${prop.student_id}`
            : key === "class_id"
            ? `&class_id=${prop.class_id}`
            : key === "start_date"
            ? `&start_date=${prop.start_date}`
            : key === "end_date"
            ? `&end_date=${prop.end_date}`
            : "";
      }
    }
    if (Object.keys(prop).length !== 0)
      param = `?${param.slice(1, param.length)}`;
  }
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/student-attendance-all${param}`,
    "GET"
  );
}
/**
 * 출석부 조회 - 새로운 API
 * @param prop class_id: number, start_date: string, end_date: string
 * @ 일간: start_date = end_date, 월간: start_date = 1, end_date = 28/29/30/31
 * @returns
 */
export async function getAttendanceTotal(prop?: any): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/student-attendance/student-all?class_id=${prop.class_id}&start_date=${prop.start_date}&end_date=${prop.end_date}`, "GET");
}

/**
 * 출석부 한명 조회 - 새로운 API
 * @param prop class_id: number, start_date: string, end_date: string
 * @ 일간: start_date = end_date, 월간: start_date = 1, end_date = 28/29/30/31
 * @returns
 */
export async function getAttendanceStudentOne(studentId: number, prop?: any): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/student-attendance/student/${studentId}?start_date=${prop.start_date}&end_date=${prop.end_date}`, "GET");
}


/**
 * 출석부 통계 카운트 조회
 */
export async function getAttendanceCount(param:AttendanceCountQueryParams): Promise<any> {
    globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
    return await apiRequestHandler(`/v1/sites/${SITEID}/student-attendance/attendance-count?class_id=${param.class_id}&date=${param.date}`, "GET");
}

/**
 * 일별 출석 등록
 * @param data 
 * @returns 
 */
export async function createAttendance(data: any): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/student-attendance`,
    "POST",
    data
  );
}
/**
 * 일별 출석 수정
 * @param data 
 * @param attendanceId 
 * @returns 
 */
export async function updateAttendance(data: any, attendanceId:number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/student-attendance/${attendanceId}`, "PUT", data
  );
}

// --------------------------- 출석부 관련 끝 ------------------------------------
// --------------------------- 수납 관련 시작 ------------------------------------
/**
 * 수납 정보 조회
 * @param prop page: number, size: number, name: string
 * @returns
 */
export async function getPayments(prop?: any): Promise<any> {
  // console.log("getPayments prop ", prop);
  let param = "";
  if (prop !== undefined) {
    for (let i = 0; i < Object.keys(prop).length; i++) {
      let key = Object.keys(prop)[i];
      let value = prop[key];
      if (Number(value) !== 0) {
        param +=
          key === "page"
            ? `&page=${prop.page}`
            : key === "size"
            ? `&size=${prop.size}`
            : key === "name"
            ? `&name=${prop.name}`
            : key === "type"
            ? `&type=${prop.type}`
            : "";
      }
    }
    if (Object.keys(prop).length !== 0)
      param = `?${param.slice(1, param.length)}`;
  }
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/payment-info-all${param}`,
    "GET"
  );
}
/**
 * 수납 정보 등록
 */
export async function postPayments(data: any): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/payment-info`,
    "POST",
    data
  );
}
export async function putPayments(data: any, payment_info_id: number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/payment-info/${payment_info_id}`,
    "PUT",
    data
  );
}
/**
 * 할인 정보 조회
 * @param prop page: number, size: number, name: string
 * @returns
 */
export async function getDiscounts(prop?: any): Promise<any> {
  // console.log("getDiscounts prop ", prop);
  let param = "";
  if (prop !== undefined) {
    for (let i = 0; i < Object.keys(prop).length; i++) {
      let key = Object.keys(prop)[i];
      let value = prop[key];
      if (Number(value) !== 0) {
        param +=
          key === "page"
            ? `&page=${prop.page}`
            : key === "size"
            ? `&size=${prop.size}`
            : key === "name"
            ? `&name=${prop.name}`
            : "";
      }
    }
    if (Object.keys(prop).length !== 0)
      param = `?${param.slice(1, param.length)}`;
  }
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/discount-info-all${param}`,
    "GET"
  );
}
export async function getDiscountOne(discount_info_id: number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/discount-info-all/${discount_info_id}`,
    "GET"
  );
}
/**
 * 할인/프로모션 정보 등록
 */
export async function postDiscounts(data: any): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/discount-info`,
    "POST",
    data
  );
}
export async function putDiscounts(data: any, discount_info_id: number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/discount-info/${discount_info_id}`,
    "PUT",
    data
  );
}
/**
 * 청구서 내역 조회
 * @param prop page: number, size: number, name: string
 * @returns
 */
export async function getAllReceipt(prop?: any): Promise<any> {
  // console.log("getAllReceipt prop ", prop);
  let param = "";
  if (prop !== undefined) {
    for (let i = 0; i < Object.keys(prop).length; i++) {
      let key = Object.keys(prop)[i];
      let value = prop[key];
      if (Number(value) !== 0) {
        param +=
          key === "page"
            ? `&page=${prop.page}`
            : key === "size"
            ? `&size=${prop.size}`
            : key === "status"
            ? `&status=${prop.status}`
            : key === "user_id"
            ? `&user_id=${prop.user_id}`
            : key === "student_id"
            ? `&student_id=${prop.student_id}`
            : key === "date_type"
            ? `&date_type=${prop.date_type}`
            : key === "start_date"
            ? `&start_date=${prop.start_date}`
            : key === "end_date"
            ? `&end_date=${prop.end_date}`
            : "";
      }
    }
    if (Object.keys(prop).length !== 0)
      param = `?${param.slice(1, param.length)}`;
  }
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/receipt-log-all${param}`,
    "GET"
  );
}
/**
 * 청구서 등록
 */
export async function postReceipt(data: any): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(
    `/v1/sites/${SITEID}/receipt-log`,
    "POST",
    data
  );
}
// --------------------------- 수납 관련 끝 ------------------------------------

// --------------------------- 로그인 관련 시작 ------------------------------------
//로그인
export async function adminLogin(data: LoginInfo): Promise<any> {
  // console.log("adminLogin ", data);
  return await apiRequestHandler(`/v1/auth/login`, "POST", data);
}
//로그아웃
export async function adminLogout(): Promise<any> {
  const result = await apiRequestHandler(`/v1/auth/logout`, "POST");
  return result;
}
//비밀번호 변경
export async function updatePassword(data: any): Promise<any> {
  return await apiRequestHandler(`/v1/auth/change-login-pw`, "POST", data);
}
//아이디 찾기
export async function findLoginId(data: any): Promise<any> {
  return await apiRequestHandler(`/v1/auth/find-login-id`, "POST", data);
}
//비밀번호 찾기
export async function findLoginPw(data: any): Promise<any> {
  return await apiRequestHandler(`/v1/auth/find-login-pw`, "POST", data);
}
//비밀번호 찾기 후 변경
export async function updatePasswordAfterFind(data: any): Promise<any> {
  return await apiRequestHandler(`/v1/auth/find-login-pw-change`, "POST", data);
}
//회원탈퇴 전 아이디/패스워드 확인
export async function checkLoginIdPw(data: any): Promise<any> {
  return await apiRequestHandler(`/v1/auth/check-login-id-pw`, "POST", data);
}


export function removeStorage() {
  localStorage.removeItem(ACCESS_TOKEN_NAME);
  localStorage.removeItem(USER_ROLE);
  localStorage.removeItem(USER_ID);
  localStorage.removeItem(SITE_ID_LIST);
  localStorage.removeItem(SELECT_SITE_ID);
}

// 로그인 header 정보
export const ACCESS_TOKEN_NAME = "access-token";
export const USER_ID = "user-id";
export const USER_ROLE = "user-role";
export const SITE_ID_LIST = "site-id-list";
export const SELECT_SITE_ID = "select-site-id";

// --------------------------- 로그인 관련 끝 ------------------------------------
//서버 API 응답 데이터 모델
interface ResponseData {
  code: number;
  message: string;
  data: any;
  total_count: number;
  setProperty:(resData:ResponseData) => void;
}

class ResponseDataImpl implements ResponseData {
  public code: number;
  public data: any;
  public message: string;
  public total_count: number;

  constructor() {
    this.code = 0;
    this.message = "";
    this.data = {};
    this.total_count = 0;
  }

  setProperty(resData: ResponseData) {
      this.code = resData.code;
      this.message = resData.message;
      this.data = resData.data;
      this.total_count = resData.total_count;
  }
}

//응답 데이터가 ResponseData 타입인지 확인
function isResponseData(data: any): data is ResponseData {
  return (typeof data.code === 'number' && typeof data.message === 'string');
}



// 헤더 정보 저장
async function setHeaders(headers: Headers): Promise<void> {
  const accessToken = headers.get(ACCESS_TOKEN_NAME);
  const roleCode = headers.get(USER_ROLE);
  const loginId = headers.get(USER_ID);
  const siteIdList = headers.get(SITE_ID_LIST);

  if (accessToken) localStorage.setItem(ACCESS_TOKEN_NAME, accessToken);
  if (roleCode) localStorage.setItem(USER_ROLE, roleCode);
  if (loginId) localStorage.setItem(USER_ID, loginId);
  if (siteIdList) localStorage.setItem(SITE_ID_LIST, siteIdList);
  if (siteIdList){
    // 선택된 사이트가 없으면 첫번째 사이트 선택
    if(!localStorage.getItem(SELECT_SITE_ID)){
      localStorage.setItem(SELECT_SITE_ID, JSON.parse(siteIdList)[0]);
    }
  }
}

//에러 핸들러
export function errorHandler(errorData: ResponseData | unknown): ResponseData {

  // 에러가 ResponseData 타입인 경우
  if (isResponseData(errorData)) {
      // switch (errorData.code) {
      //   case 400:
      //     alert("잘못된 요청입니다.");
      //     break;
      //   case 401:
      //     alert("로그인 정보가 만료되었거나 유효하지 않습니다. 다시 로그인 해주세요.");
      //     window.location.href = "/login";
      //     break;
      //   case 403:
      //     alert("권한이 없습니다.");
      //     break;
      //   case 404:
      //     alert("요청하신 정보를 찾을 수 없습니다.");
      //     break;
      //   case 500:
      //     alert("서버에 문제가 발생했습니다. 잠시 후 다시 시도해주세요.");
      //     break;
      //   default:
      //     alert(errorData.message);
      // }

      return errorData;
  }
  // 에러가 Error 타입인 경우
  else if(errorData instanceof Error){
    alert("서버와의 통신에 문제가 발생했습니다. 잠시 후  다시 시도해주세요.");
  }
  // 그 외의 경우
  else {
    alert("서버와의 통신에 문제가 발생했습니다. 잠시 후  다시 시도해주세요.");
  }

  // 에러가 ResponseData 타입이 아닌 경우 빈 객체 반환
  return new ResponseDataImpl();
}


// API 요청 함수
export async function apiRequestHandler(path: string, method: string, body?: any):Promise<ResponseData> {

  const result:ResponseData = new ResponseDataImpl();

  const timeoutController = new TimeoutController();
  timeoutController.startTimeout(); // 타임아웃 시작

  try {
      globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));

      const response:Response = await fetch(`${url}${path}`, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          [ACCESS_TOKEN_NAME]: localStorage.getItem(ACCESS_TOKEN_NAME) || "",
          // [REFRESH_TOKEN_NAME]: localStorage.getItem(REFRESH_TOKEN_NAME) || "",
          // [USER_ROLE]: localStorage.getItem(USER_ROLE) || "",
          // [LOGIN_SORT]: localStorage.getItem(LOGIN_SORT) || "",
          // [USER_ID]: localStorage.getItem(USER_ID) || "",
          // [SITE_ID_LIST]: localStorage.getItem(SITE_ID_LIST) || ""
        },
        credentials: "include",
        body: JSON.stringify(body),
        signal: timeoutController.signal, // signal 전달
      });

      //헤더정보 저장
      await setHeaders(response.headers);

      //응답 데이터 저장
      result.setProperty(await response.json());
    
      //성공이 아닌 경우 에러 핸들러 호출
      if(result.code !== 200){
        errorHandler(result);
      }
  }
  catch (err:any) {
      // 에러 핸들러 호출
      result.setProperty(errorHandler(err));
  }
  finally {
      // 타임아웃 종료
      timeoutController.clearTimeout();
  }

  return result;
}

// formData용 API 요청 함수
export async function formDataApiRequestHandler(path: string, method: string, body?: any): Promise<ResponseData> {

  const result:ResponseData = new ResponseDataImpl();

  try {
    const response = await fetch(`${url}${path}`, {
      method: method,
      headers: {
        // "Content-Type": "multipart/form-data",
        [ACCESS_TOKEN_NAME]: localStorage.getItem(ACCESS_TOKEN_NAME) || "",
        // [REFRESH_TOKEN_NAME]: localStorage.getItem(REFRESH_TOKEN_NAME) || "",
        // [USER_ROLE]: localStorage.getItem(USER_ROLE) || "",
        // [LOGIN_SORT]: localStorage.getItem(LOGIN_SORT) || "",
        // [USER_ID]: localStorage.getItem(USER_ID) || "",
        // [SITE_ID_LIST]: localStorage.getItem(SITE_ID_LIST) || ""
      },
      credentials: "include",
      body: body,
    });
    //헤더정보 저장
    await setHeaders(response.headers);

    //응답 데이터 저장
    result.setProperty(await response.json());
  }
  catch (err) {
    result.setProperty(errorHandler(err));
  }
  return result;
}

// 이미지/문서 불러오기 API 요청 함수
export async function downloadApiRequestHandler(path: string, method: string, body?: any): Promise<Blob | undefined> {
  try {
    const response = await fetch(`${url}${path}`, {
      method: method,
      headers: {
        // "Content-Type": "multipart/form-data",
        [ACCESS_TOKEN_NAME]: localStorage.getItem(ACCESS_TOKEN_NAME) || "",
        // [REFRESH_TOKEN_NAME]: localStorage.getItem(REFRESH_TOKEN_NAME) || "",
        // [USER_ROLE]: localStorage.getItem(USER_ROLE) || "",
        // [LOGIN_SORT]: localStorage.getItem(LOGIN_SORT) || "",
        // [USER_ID]: localStorage.getItem(USER_ID) || "",
        // [SITE_ID_LIST]: localStorage.getItem(SITE_ID_LIST) || ""
      },
      credentials: "include",
      body: body,
    });
    //헤더정보 저장
    await setHeaders(response.headers);
    return await response.blob();
  }
  catch (err) {
    errorHandler(err);
  }

  return undefined;
}

//단말기 전체 조회
export async function getDeviceListHandler(params?: any): Promise<any> {

    globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
    return await apiRequestHandler(`/v1/sites/${SITEID}/device-all`, "GET");
}
//단말기 등록
export async function createDeviceHandler(data: DeviceRequestType): Promise<any> {
    globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
    return await apiRequestHandler(`/v1/sites/${SITEID}/device`, "POST", data);
}
//단말기 수정
export async function updateDeviceHandler(deviceId:number, data: DeviceRequestType): Promise<any> {
    globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
    return await apiRequestHandler(`/v1/sites/${SITEID}/device/${deviceId}`, "PUT", data);
}

//단말기 삭제
export async function removeDeviceHandler(deviceId:number): Promise<any> {
    globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
    return await apiRequestHandler(`/v1/sites/${SITEID}/device/${deviceId}`, "DELETE");
}

//학생 등록
export async function createStudentHandler(data:StudentRequestType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/student`, "POST", data);
}
//학생 수정
export async function updateStudentHandler(studentId:number, data:StudentRequestType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/student/${studentId}`, "PUT", data);
}

//학생 삭제
export async function removeStudentHandler(studentId:number): Promise<any> {
    globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
    return await apiRequestHandler(`/v1/sites/${SITEID}/student/${studentId}`, "DELETE");
}

//학생 일괄 삭제
export async function removeStudentAllHandler(data: any): Promise<any> {
    globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
    return await apiRequestHandler(`/v1/sites/${SITEID}/student/delete-all`, "DELETE", data);
}

//엑셀 학생 일괄 등록
export async function createStudentExcelHandler(data: FormData,classId:number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await formDataApiRequestHandler(`/v1/sites/${SITEID}/student/bulk-upload-create/${classId}`, "POST", data);
}

//엑셀 반 일괄 이동 - 우선 addStudentToClassHandler(반에 학생 추가)와 동일함
export async function updateStudentClassExcelHandler(classId:number,data:ClassAddStudentType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/class/add-student/${classId}`, "PUT", data);
}

//원 정보 수정
export async function updateSiteHandler(data:SitePostType): Promise<any> {
    globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
    return await apiRequestHandler(`/v1/site/${SITEID}`, "PUT", data);
}

//반 등록
export async function createClassHandler(data: ClassRequestType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/class`, "POST", data);
}
//반 수정
export async function updateClassHandler(classId:number, data: ClassRequestType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/class/${classId}`, "PUT", data);
}
//반 삭제
export async function removeClassHandler(classId:number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/class/${classId}`, "DELETE");
}

//반에 학생 추가
export async function addStudentToClassHandler(classId:number,data:ClassAddStudentType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/class/add-student/${classId}`, "PUT", data);
}


//사용자 추가
export async function createUserHandler(data: UserPostType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/user`, "POST", data);
}

//사용자 수정
export async function updateUserHandler(userId:number, data: UserPostType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/user/${userId}`, "PUT", data);
}

//사용자 삭제
export async function deleteUserHandler(userId:number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/user/${userId}`, "DELETE");
}

//학생 단말기 동기화 요청
export async function syncStudentDeviceHandler(data: SyncStudentDeviceRequestType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/student/device-sync`, "POST", data);
}

/**
 * 차량 조회
 * @param prop 
 * @returns 
 */
export async function getBuses(prop?: any): Promise<any> {

  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/bus-all`, "GET");
}

// 차량 등록
export async function createBusInfo(data: BusRequestType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/bus`, "POST", data);
}
// 차량 수정
export async function updateBusInfo(busId:number, data: BusRequestType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/bus/${busId}`, "PUT", data);
}
// 차량 삭제
export async function removeBusInfo(busId:number): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/sites/${SITEID}/bus/${busId}`, "DELETE");
}

//DDNS 등록
export async function createDdnsHandler(data: DdnsRequestType): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/site/${SITEID}/ddns-update`, "PUT", data);
}

//DDNS 삭제
export async function removeDdnsHandler(): Promise<any> {
  globalSiteIdUpdate(Number(localStorage.getItem(SELECT_SITE_ID)));
  return await apiRequestHandler(`/v1/site/${SITEID}/ddns-delete`, "DELETE");
}